(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/iam-postmessage/assets/javascripts/iam-parent-communication.js') >= 0) return;  svs.modules.push('/components/accountservices/iam-postmessage/assets/javascripts/iam-parent-communication.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  logger
} = svs.accountservices.iamPostMessage;
const {
  POST_MESSAGE_SOURCES,
  POST_MESSAGE_TYPES,
  isOriginTrusted
} = svs.accountservices.iamPostMessage;

const noopLogger = {
  debug: () => {},
  info: () => {},
  warn: () => {},
  error: () => {}
};

class IamParentCommunication {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.source = options.source || POST_MESSAGE_SOURCES.PARENT;
    this.iframeId = options.iframeId || 'iamlogin-iframe';
    this.logger = options.logger || logger || noopLogger;
    this.messageHandlers = new Map();
  }

  getIframe() {
    return document.getElementById(this.iframeId);
  }

  _resolveIframeOrigin() {
    try {
      const iframe = this.getIframe();
      if (iframe && iframe.src) {
        const origin = new URL(iframe.src).origin;
        if (origin && origin !== 'null') {
          return origin;
        }
      }
    } catch (e) {
      this.logger.debug('Could not resolve iframe origin from src', e);
    }
    this.logger.warn('Could not determine iframe origin from src, falling back to parent origin');
    return window.location.origin;
  }

  sendToIframe(message, targetOrigin) {
    const iframe = this.getIframe();
    if (!iframe || !iframe.contentWindow) {
      this.logger.warn('Iframe not found or not ready');
      return false;
    }
    const resolvedOrigin = targetOrigin || this._resolveIframeOrigin();
    const payload = _objectSpread(_objectSpread({}, message), {}, {
      source: this.source
    });
    iframe.contentWindow.postMessage(payload, resolvedOrigin);
    return true;
  }

  onMessage(messageType, handler) {
    this.messageHandlers.set(messageType, handler);
  }

  listen() {
    let expectedSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : POST_MESSAGE_SOURCES.IFRAME;
    const handleMessage = async event => {
      if (!event.origin || !isOriginTrusted(event)) {
        this.logger.warn('Received postMessage from untrusted origin', event.origin);
        return;
      }
      const data = event && event.data;

      if (!data || typeof data !== 'object' || data.source !== expectedSource || !Object.values(POST_MESSAGE_TYPES).includes(data.messageType)) {
        this.logger.debug('Ignoring postMessage with unexpected format or source', data);
        return;
      }
      const iframe = this.getIframe();
      const messageType = data.messageType;
      if (messageType && this.messageHandlers.has(messageType)) {
        const handler = this.messageHandlers.get(messageType);
        try {
          await handler(event, iframe);
        } catch (error) {
          this.logger.error("Error handling message type ".concat(messageType, ":"), error);
        }
      }
    };
    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }

  startListening() {
    let expectedSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : POST_MESSAGE_SOURCES.IFRAME;
    return this.listen(expectedSource);
  }
}

svs.accountservices.iamPostMessage.IamParentCommunication = IamParentCommunication;

 })(window);